export const versionApp = "V 1.0.2";
